import axios, { AxiosRequestConfig, Method } from 'axios';
import { RequstMethods } from './requestMethode';


export default async function makeUploadRequest(url: string, method: Method, formData?: any) {
    let requestConfig: AxiosRequestConfig = {
        baseURL: `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_API_VER}`,
        url: url,
        method: method,
        headers: {
            Authorization: localStorage.getItem("authKey") || "",
            "Content-Type": "multipart/form-data",
        }
    };

    if (method !== RequstMethods.GET && formData) {
        requestConfig.data = formData;
    }

    return await axios.request(requestConfig);
}
